import MoreVertIcon from '@mui/icons-material/MoreVert'
import { IconButton, Menu } from '@mui/material'
import React, { useState } from 'react'
import styled from 'styled-components'

import { useAppContext } from '@/hooks'

type NodeButtonsProps = {
	buttons?: React.ReactNode
	moreButtons?: React.ReactNode
}

export const NodeButtons = ({ buttons, moreButtons }: NodeButtonsProps) => {
	const { t } = useAppContext()
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<ButtonsContainer>
			{buttons}

			{moreButtons && (
				<>
					<IconButton
						aria-label={t('MORE_ACTIONS')}
						onClick={handleOpen}
						size="small"
					>
						<MoreVertIcon />
					</IconButton>
				<Menu
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					onClick={handleClose}
					keepMounted
					slotProps={{
						paper: {
							sx: { minWidth: 180 },
						},
					}}
				>
						{moreButtons}
					</Menu>
				</>
			)}
		</ButtonsContainer>
	)
}

const ButtonsContainer = styled.div`
	display: flex;
	height: 100%;
	position: relative;
	align-items: center;
`
